import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { resetPassword } from '../../actions/authentication';
// import { storeWithExpiration } from '../../utils/common';
// import { VALID_EMAIL_REGEX } from '../../config/app_config';
import CreateCustomerAccountForm from './CreateCustomerAccountForm';

const FORM_ID = 'createCustomerAccountForm';

export class CreateCustomerAccountContainer extends React.Component {
  static propTypes = {
    resetPasswordAction: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  performCreateAccount = (securityToken, params) => {
    const { resetPasswordAction } = this.props;
    const credentials = {
      plainTextPassword: String(params.password),
      securityToken,
    };
    resetPasswordAction(credentials, '/home');
  };

  render() {
    const { handleSubmit, location, invalid, submitting } = this.props;
    const securityToken = location.query.auth;

    return (
      <div className="container form-only">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-block">
              <h2 className="card-title">Create Account</h2>
              <p className="card-text" style={{ marginBottom: 0 }}>
                One last step to create your account...<br />
                <em>Create a password to complete your Customer Portal account setup</em>
              </p>
              <div className="row">
                <div className="col-xs-12">
                  <CreateCustomerAccountForm
                    invalid={invalid}
                    handleSubmit={handleSubmit}
                    createAccountFunction={this.performCreateAccount}
                    securityToken={securityToken}
                    submitting={submitting}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <span className="pull-right">
                    Already have an account? <Link to="/account/login">Log In</Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  // if (!values.firstName || values.firstName === '') {
  //   errors.firstName = 'First Name Required';
  // }
  // if (!values.lastName || values.lastName === '') {
  //   errors.lastName = 'Last Name Required';
  // }
  // if (!values.email || values.email === '') {
  //   errors.email = 'Required';
  // }
  // else if (!VALID_EMAIL_REGEX.test(values.email)) {
  //   errors.email = 'Invalid email address';
  // }
  // if (!values.accountTypeId || values.accountTypeId === '') {
  //   errors.accountTypeId = 'Required';
  // }
  if (!values.password || values.password === '') {
    errors.password = 'Required';
  } else if (values.password.length < 8) {
    errors.password = 'Must Be 8 Characters or More';
  } else if (!values.password.match(/^(?=.*[a-z])(?=.*[A-Z]).+$/)) {
    errors.password = 'Must contain at least one uppercase and lowercase letter';
  } else if (!values.password.match(/^(?=.*\d).+$/)) {
    errors.password = 'Must contain at least one number';
  }
  if (!values.confirmPassword || values.confirmPassword === '') {
    errors.confirmPassword = 'Required';
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords must match';
  }
  return errors;
};

const CreateCustomerAccountContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(CreateCustomerAccountContainer);

export default connect(null, {
  resetPasswordAction: resetPassword,
})(CreateCustomerAccountContainerRF);
